import React from "react";
import type { RbacPolicyProps } from "./RbacPolicies";
import { useRbacContext } from "./RbacProvider";

type PolicyAuthorizedProps = React.PropsWithChildren<{
  policies: RbacPolicyProps;
}>;

export function PolicyAuthorized(props: PolicyAuthorizedProps) {
  const { isAuthorized } = useRbacContext();
  return <>{isAuthorized(props.policies) ? props.children : undefined}</>;
}
